var _a, _b, _c, _d, _e, _f, _g, _h;
import { __decorate, __metadata } from "tslib";
import fornecService from "@/core/services/fornecService";
import JwtService from "@/core/services/JwtService";
import { Mutations } from "@/store/enums/StoreEnums";
import { Categoria_CNHActions } from "@/store/enums/FornecEnums";
import { Module, Action, VuexModule } from "vuex-module-decorators";
let Categoria_CNHModule = class Categoria_CNHModule extends VuexModule {
    constructor() {
        super(...arguments);
        this.errors = {};
        this.isAuthenticated = !!JwtService.getToken();
    }
    [_a = Categoria_CNHActions.POST_CATEGORIA_CNH](data) {
        return new Promise(resolve => {
            fornecService.post("Categoria_CNH/Post", data)
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
    [_b = Categoria_CNHActions.PUT_CATEGORIA_CNH](data) {
        return new Promise(resolve => {
            fornecService.put("Categoria_CNH/Put", data)
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
    [_c = Categoria_CNHActions.DELETE_CATEGORIA_CNH](data) {
        return new Promise(resolve => {
            fornecService.delete("Categoria_CNH/Delete", data)
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
    [_d = Categoria_CNHActions.DELETE_RANGE_CATEGORIA_CNH](data) {
        return new Promise(resolve => {
            fornecService.delete("Categoria_CNH/DeleteRange", data)
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
    [_e = Categoria_CNHActions.FILTER_CATEGORIA_CNH](data) {
        return new Promise(resolve => {
            fornecService.post("Categoria_CNH/Filter", data)
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
    [_f = Categoria_CNHActions.GET_CATEGORIA_CNH]() {
        return new Promise(resolve => {
            fornecService.get("Categoria_CNH/Get")
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
    [_g = Categoria_CNHActions.GETWITHDISABLED_CATEGORIA_CNH]() {
        return new Promise(resolve => {
            fornecService.get("Categoria_CNH/GetWithDisabled")
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
    [_h = Categoria_CNHActions.GET_BY_ID_CATEGORIA_CNH](data) {
        return new Promise(resolve => {
            fornecService.get("Categoria_CNH/GetById", data)
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
};
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], Categoria_CNHModule.prototype, _a, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], Categoria_CNHModule.prototype, _b, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], Categoria_CNHModule.prototype, _c, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], Categoria_CNHModule.prototype, _d, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], Categoria_CNHModule.prototype, _e, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], Categoria_CNHModule.prototype, _f, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], Categoria_CNHModule.prototype, _g, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], Categoria_CNHModule.prototype, _h, null);
Categoria_CNHModule = __decorate([
    Module
], Categoria_CNHModule);
export default Categoria_CNHModule;
//# sourceMappingURL=Categoria_CNHModule.js.map